import { render, staticRenderFns } from "./studentAdmission.vue?vue&type=template&id=5bbe8d21&scoped=true&"
import script from "./studentAdmission.vue?vue&type=script&lang=js&"
export * from "./studentAdmission.vue?vue&type=script&lang=js&"
import style0 from "./studentAdmission.vue?vue&type=style&index=0&lang=css&"
import style1 from "./studentAdmission.vue?vue&type=style&index=1&id=5bbe8d21&scoped=true&lang=css&"
import style2 from "./studentAdmission.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbe8d21",
  null
  
)

export default component.exports